import intToReal from '@helpers/intToReal';

(function () {
  'use srict';
  const RULES = {
    1: {
      range: 1,
      rows: [
        {
          hits: 1,
          topPrize: 2.5,
          goldenBall: 50
        }
      ]
    },
    2: {
      range: 2,
      rows: [
        {
          hits: 2,
          topPrize: 4,
          goldenBall: 70
        },
        {
          hits: 1,
          topPrize: 1,
          goldenBall: 10
        }
      ]
    },
    3: {
      range: 3,
      rows: [
        {
          hits: 3,
          topPrize: 20,
          goldenBall: 180
        },
        {
          hits: 2,
          topPrize: 2.5,
          goldenBall: 12
        },
        {
          hits: 1,
          topPrize: 0,
          goldenBall: 5
        }
      ]
    },
    4: {
      range: 4,
      rows: [
        {
          hits: 4,
          topPrize: 70,
          goldenBall: 400
        },
        {
          hits: 3,
          topPrize: 4,
          goldenBall: 30
        },
        {
          hits: 2,
          topPrize: 1,
          goldenBall: 6
        },
        {
          hits: 1,
          topPrize: 0,
          goldenBall: 5
        }
      ]
    },
    5: {
      range: 5,
      rows: [
        {
          hits: 5,
          topPrize: 300,
          goldenBall: 2000
        },
        {
          hits: 4,
          topPrize: 13,
          goldenBall: 40
        },
        {
          hits: 3,
          topPrize: 3,
          goldenBall: 6
        },
        {
          hits: 2,
          topPrize: 0,
          goldenBall: 4
        },
        {
          hits: 1,
          topPrize: 0,
          goldenBall: 4
        }
      ]
    },
    6: {
      range: 6,
      rows: [
        {
          hits: 6,
          topPrize: 750,
          goldenBall: 5000
        },
        {
          hits: 5,
          topPrize: 15,
          goldenBall: 100
        },
        {
          hits: 4,
          topPrize: 7,
          goldenBall: 20
        },
        {
          hits: 3,
          topPrize: 2,
          goldenBall: 6
        },
        {
          hits: 2,
          topPrize: 0,
          goldenBall: 4
        },
        {
          hits: 1,
          topPrize: 0,
          goldenBall: 4
        }
      ]
    },
    7: {
      range: 7,
      rows: [
        {
          hits: 7,
          topPrize: 3000,
          goldenBall: 14000
        },
        {
          hits: 6,
          topPrize: 110,
          goldenBall: 400
        },
        {
          hits: 5,
          topPrize: 20,
          goldenBall: 50
        },
        {
          hits: 4,
          topPrize: 2,
          goldenBall: 8
        },
        {
          hits: 3,
          topPrize: 1,
          goldenBall: 5
        },
        {
          hits: 2,
          topPrize: 0,
          goldenBall: 4
        },
        {
          hits: 1,
          topPrize: 0,
          goldenBall: 4
        }
      ]
    },
    8: {
      range: 8,
      rows: [
        {
          hits: 8,
          topPrize: 10000,
          goldenBall: 40000,
          maximumGoldenBallAmount: 1320000
        },
        {
          hits: 7,
          topPrize: 400,
          goldenBall: 1000
        },
        {
          hits: 6,
          topPrize: 25,
          goldenBall: 100
        },
        {
          hits: 5,
          topPrize: 10,
          goldenBall: 30
        },
        {
          hits: 4,
          topPrize: 2,
          goldenBall: 6
        },
        {
          hits: 3,
          topPrize: 0,
          goldenBall: 3
        },
        {
          hits: 2,
          topPrize: 0,
          goldenBall: 3
        },
        {
          hits: 1,
          topPrize: 0,
          goldenBall: 4
        },
        {
          hits: 0,
          topPrize: 1,
          goldenBall: 0
        }
      ]
    },
    9: {
      range: 9,
      rows: [
        {
          hits: 9,
          topPrize: 50000,
          goldenBall: 120000,
          maximumGoldenBallAmount: 2100000,
          maximumTopPrizeAmount: 1650000
        },
        {
          hits: 8,
          topPrize: 2500,
          goldenBall: 8000
        },
        {
          hits: 7,
          topPrize: 150,
          goldenBall: 300
        },
        {
          hits: 6,
          topPrize: 20,
          goldenBall: 50
        },
        {
          hits: 5,
          topPrize: 7,
          goldenBall: 16
        },
        {
          hits: 4,
          topPrize: 0,
          goldenBall: 4
        },
        {
          hits: 3,
          topPrize: 0,
          goldenBall: 3
        },
        {
          hits: 2,
          topPrize: 0,
          goldenBall: 3
        },
        {
          hits: 1,
          topPrize: 0,
          goldenBall: 4
        },
        {
          hits: 0,
          topPrize: 1,
          goldenBall: 0
        }
      ]
    },
    10: {
      range: 10,
      rows: [
        {
          hits: 10,
          topPrize: 200000,
          goldenBall: 400000,
          maximumGoldenBallAmount: 3600000,
          maximumTopPrizeAmount: 3000000
        },
        {
          hits: 9,
          topPrize: 7000,
          goldenBall: 16000
        },
        {
          hits: 8,
          topPrize: 1000,
          goldenBall: 3000
        },
        {
          hits: 7,
          topPrize: 50,
          goldenBall: 200
        },
        {
          hits: 6,
          topPrize: 15,
          goldenBall: 30
        },
        {
          hits: 5,
          topPrize: 2,
          goldenBall: 5
        },
        {
          hits: 4,
          topPrize: 0,
          goldenBall: 3
        },
        {
          hits: 3,
          topPrize: 0,
          goldenBall: 2
        },
        {
          hits: 2,
          topPrize: 0,
          goldenBall: 3
        },
        {
          hits: 1,
          topPrize: 0,
          goldenBall: 4
        },
        {
          hits: 0,
          topPrize: 1,
          goldenBall: 0
        }
      ]
    }
  };

  const MAXIMUM_GOLDEN_BALL_AMOUNT = 3600000;
  const MAXIMUM_TOP_PRIZE_AMOUNT = 3000000;

  new Vue({
    el: '[data-vue="table-awards-keno-minas"]',
    data () {
      return {
        rules: RULES,
        numberOfHits: 1,
        amountBetted: 3
      }
    },
    methods: {
      intToReal,
      calcTopPrize (rule, amountBetted) {
        const amount = rule.topPrize * amountBetted;

        if (rule.maximumTopPrizeAmount && amount > rule.maximumTopPrizeAmount) {
          return intToReal(rule.maximumTopPrizeAmount);
        }

        if (amount > MAXIMUM_TOP_PRIZE_AMOUNT) {
          return intToReal(MAXIMUM_TOP_PRIZE_AMOUNT);
        }

        return intToReal(amount);
      },
      calcGoldenBall (rule, amountBetted) {
        const amount = rule.goldenBall * amountBetted;

        if (rule.maximumGoldenBallAmount && amount > rule.maximumGoldenBallAmount) {
          return intToReal(rule.maximumGoldenBallAmount);
        }

        if (amount > MAXIMUM_GOLDEN_BALL_AMOUNT) {
          return intToReal(MAXIMUM_GOLDEN_BALL_AMOUNT);
        }

        return intToReal(amount);
      }
    },
    mounted () {
    }
  });
})(window);
